import React from 'react';
import Button, { ButtonProps } from '@material-ui/core/Button';
import T from 'i18n-react';
import withStyles from '@material-ui/core/styles/withStyles';
import PersonIcon from '@material-ui/icons/Person';
import Badge, { BadgeProps } from '@material-ui/core/Badge';

type SquareButtonProps = ButtonProps & {
  following: boolean,
  totalCount: number,
  isMouseEntered: boolean,
  mouseEnter: boolean,
};

const StyledButton: React.FC<ButtonProps> = withStyles((theme) => ({
  root: {
    maxWidth: 400,
    [theme.breakpoints.up('sm')]: {
      maxWidth: 200,
    },
  },
  label: {
    fontWeight: 'bold',
  },
}))(Button);

const StyledBadge: React.FC<BadgeProps> = withStyles((theme) => ({
  badge: {
    right: -6,
    top: 10,
    padding: theme.spacing(0, 0.5),
  },
}))(Badge);

const SquareButton = ({
  following,
  totalCount,
  isMouseEntered,
  mouseEnter,
  children,
  ...props
}: SquareButtonProps) => {
  return (
    <StyledButton
      variant={following ? 'contained' : 'outlined'}
      color={isMouseEntered ? 'secondary' : 'primary'}
      fullWidth
      disableElevation
      {...(totalCount > 0 && {
        endIcon: (
          <StyledBadge badgeContent={totalCount} max={999}>
            <PersonIcon fontSize="small" />
          </StyledBadge>
        ),
      })}
      {...props}
    >
      {children ||
        (following
          ? T.translate(mouseEnter ? 'business.unfollow' : 'business.following')
          : T.translate('business.follow'))}
    </StyledButton>
  );
};

export default SquareButton;
